import React, { useContext, useEffect, useState } from "react";
import { Box, Button, ResponsiveContext, Text } from "grommet";
import { useValidationDate } from "../../../customHooks/useValidationDate";
import { isMobileTabletResponsive, objectEqual } from "../../../utils/utils";
import { TextInput } from "../../Inputs/TextInput";
import { DatePicker } from "../../Inputs/DatePicker";
export var Data = function Data(_ref) {
  var message = _ref.message,
    setStatus = _ref.setStatus,
    setMessage = _ref.setMessage,
    setNewData = _ref.setNewData;
  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);

  var _useState = useState(localStorage.user && JSON.parse(localStorage.user)),
    user = _useState[0],
    setUser = _useState[1];

  var _useState2 = useState(user == null ? void 0 : user.name),
    userName = _useState2[0],
    setUserName = _useState2[1];

  var _useState3 = useState(user == null ? void 0 : user.last_name),
    lastName = _useState3[0],
    setLastName = _useState3[1];

  var _useValidationDate = useValidationDate(user == null ? void 0 : user.birth_date),
    valueDate = _useValidationDate[0],
    handleDateChange = _useValidationDate[1],
    date = _useValidationDate[2],
    isValidDate = _useValidationDate[3];

  var _useState4 = useState(false),
    isLoading = _useState4[0],
    setLoading = _useState4[1]; // пользовательская информация хранится в LocalStorage
  // - можно попробовать хранить с помощью редакса

  useEffect(
    function () {
      setUser(localStorage.user && JSON.parse(localStorage.user)); // при рендере компонента объявляется таймер,
      // для удаления сообщений об успешном обновлении данных

      var timer = setTimeout(function () {
        setStatus(false);
        setMessage("");
      }, 5000);
      return function () {
        return clearTimeout(timer);
      };
    },
    [isLoading, setMessage, setStatus]
  ); // основная функция отправки измененных данных / для обновления информации

  var changeDataHandler = function changeDataHandler(evt) {
    setLoading(true);
    setTimeout(function () {
      return setLoading(false);
    }, 3000);
    evt.preventDefault(); // проверка новых/измененных данных

    var userNameChanges = userName && userName !== (user == null ? void 0 : user.name);
    var lastNameChanges = lastName && lastName !== (user == null ? void 0 : user.last_name);
    var dateChanges = date && objectEqual(date, new Date(user == null ? void 0 : user.birth_date)); // если обновились все - данные - обновляем все или по отдельности

    if (userNameChanges && lastNameChanges) {
      setNewData({
        name: userName,
        last_name: lastName,
        birth_date: date,
      });
    } else {
      if (userNameChanges) {
        setNewData({
          name: userName,
        });
      }

      if (lastNameChanges) {
        setNewData({
          last_name: lastName,
        });
      }

      if (dateChanges) {
        setNewData({
          birth_date: date,
        });
      } else if (!isValidDate) {
        setMessage(
          "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u0432 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435!"
        );
        setLoading(false);
      }

      if (!userNameChanges && !dateChanges && !lastNameChanges) {
        setMessage(
          "\u0414\u0430\u043D\u043D\u044B\u0435 \u043D\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u043B\u0438\u0441\u044C!"
        );
        setLoading(false);
      }
    }
  };

  var handleFocus = function handleFocus() {
    return setMessage("");
  };

  return /*#__PURE__*/ React.createElement(
    Box,
    {
      style: {
        borderRadius: "10px",
        backgroundColor: "#F8F8F8",
      },
      pad: "2rem",
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        flex: true,
        direction: "column",
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: isMobileWidth ? "column" : "row",
          gap: isMobileWidth ? "1rem" : "2rem",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "column",
            gap: "1rem",
          },
          /*#__PURE__*/ React.createElement(TextInput, {
            error: "",
            handleChange: function handleChange(event) {
              return setUserName(event.target.value);
            },
            handleFocus: handleFocus,
            name: "name",
            iconSrc: "userName",
            iconColor: "#737373",
            iconLeft: "21px",
            iconWidth: "18px",
            id: "profile-name",
            defaultValue: userName,
            valid: "",
            label: "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F",
          }),
          /*#__PURE__*/ React.createElement(DatePicker, {
            error: "",
            value: valueDate,
            onChange: handleDateChange,
            onFocus: handleFocus,
            id: "profile-birthDate",
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "column",
            gap: "1rem",
          },
          /*#__PURE__*/ React.createElement(TextInput, {
            error: "",
            handleChange: function handleChange(event) {
              return setLastName(event.target.value);
            },
            handleFocus: handleFocus,
            name: "last-name",
            iconSrc: "userName",
            iconWidth: "18px",
            iconLeft: "21px",
            iconColor: "#737373",
            id: "profile-last-name",
            defaultValue: lastName,
            valid: "",
            label: "\u0412\u0430\u0448\u0430 \u0444\u0430\u043C\u0438\u043B\u0438\u044F",
          }),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              height: "4.8rem",
              pad: {
                top: "2rem",
              },
            },
            /*#__PURE__*/ React.createElement(
              Text,
              {
                size: "small",
              },
              message
            )
          )
        )
      ),
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          align: "center",
          height: {
            max: "56px",
          },
          margin: {
            top: "2rem",
          },
          pad: {
            vertical: "1rem",
          },
          style: {
            borderRadius: "5px",
            backgroundColor: "black",
            color: "#F8F8F8",
            cursor: "pointer",
          },
          onClick: changeDataHandler,
        },
        /*#__PURE__*/ React.createElement(
          Button,
          null,
          "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
        )
      )
    )
  );
};
